// Caractères spéciaux autorisés pour les mots de passe (liste simple)
export const ALLOWED_SPECIAL_CHARS = '! @ # $ % * - _ ';

// Caractères interdits (blacklist complète)
export const FORBIDDEN_CHARS = [
  // Caractères dangereux pour la sécurité
  '<', '>', '"', "'", '&', '`', '\\', '|',
  // Caractères de contrôle et navigation
  '/', '?', '=', '+', '~', ' ', '\t', '\n', '\r',
  // Parenthèses et crochets (sauf autorisés)
  '(', ')', '[', ']', '{', '}',
  // Autres symboles problématiques
  '^', ':', ';', ',', '.',
];

// Regex pour les caractères autorisés
export const ALLOWED_ID_REGEX = /^[a-zA-Z0-9._-]+$/;
export const ALLOWED_PASSWORD_REGEX = /^[a-zA-Z0-9!@#$%*\-_]+$/;

// Messages d'erreur
export const VALIDATION_MESSAGES = {
  FORBIDDEN_CHARS: 'Caractères interdits détectés. Seuls les lettres, chiffres, points, tirets et underscores sont autorisés.',
  SPACES_NOT_ALLOWED: 'Les espaces ne sont pas autorisés.',
  INVALID_ID: 'Identifiant invalide. Utilisez uniquement : lettres, chiffres, points (.), tirets (-) et underscores (_).',
  INVALID_PASSWORD: 'Mot de passe contient des caractères non autorisés.',
};

// Fonction pour nettoyer les strings (trim + suppression caractères interdits pour ID)
export function sanitizeInput(value, type = 'id') {
  if (!value) return '';
  let sanitized = value.toString().trim();

  if (type === 'id') {
    // Pour les identifiants, on supprime tous les caractères interdits
    sanitized = sanitized.replace(/[^a-zA-Z0-9._-]/g, '');
  } else if (type === 'password') {
    // Pour les mots de passe, on supprime les caractères interdits
    sanitized = sanitized.replace(/[^a-zA-Z0-9!@#$%*\-_]/g, '');
  }

  return sanitized;
}

// Validation en temps réel
export function validateInput(value, type = 'id') {
  if (!value) return { isValid: true, message: '' };

  const trimmedValue = value.trim();

  // Vérifier les espaces
  if (trimmedValue !== value) {
    return { isValid: false, message: VALIDATION_MESSAGES.SPACES_NOT_ALLOWED };
  }

  const regex = type === 'password' ? ALLOWED_PASSWORD_REGEX : ALLOWED_ID_REGEX;

  if (!regex.test(trimmedValue)) {
    return {
      isValid: false,
      message: type === 'password' ? VALIDATION_MESSAGES.INVALID_PASSWORD : VALIDATION_MESSAGES.INVALID_ID,
    };
  }

  return { isValid: true, message: '' };
}

// Fonction pour vérifier si un caractère est autorisé
export function isCharAllowed(char, type = 'id') {
  const regex = type === 'password' ? ALLOWED_PASSWORD_REGEX : ALLOWED_ID_REGEX;
  return regex.test(char);
}
